import React, {PropsWithChildren, useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../store/reducers";
import {IMenuItem} from "../../models/menu.model";

interface AclComponentProps {
    moduleCode: string,
    subMenuItems?: IMenuItem[]
}

const AccessControlComponent = (props: PropsWithChildren<AclComponentProps>) => {

    const {children, moduleCode, subMenuItems} = props;
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);
    const [canAccess,setCanAccess]=useState<undefined|boolean>(undefined);
    useEffect(() => {
        const userAccess = currentUser?.userAccessModules||{};
        // let canAccess = userAccess && Object.keys(userAccess).includes(moduleCode);
        // let canAccess: undefined | boolean;
        if (subMenuItems && subMenuItems?.length > 0) {
            setCanAccess(subMenuItems?.some((item) => Object.keys(userAccess).includes(item.code)))
            // canAccess = subMenuItems?.some((item) => Object.keys(userAccess).includes(item.code))
        } else {
            setCanAccess(userAccess && Object.keys(userAccess).includes(moduleCode))
            // canAccess = userAccess && Object.keys(userAccess).includes(moduleCode);
        }
        if (moduleCode === 'dashboard') {
            setCanAccess(true);
            // canAccess = true;
        }
    }, [currentUser?.userAccessModules, moduleCode, subMenuItems]);
    return (
        <>
            {canAccess ? children : <></>}
        </>
    )
};

export default AccessControlComponent;
